import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Card,
  Tabs,
  Tab
} from '@material-ui/core';
import { TabPanel, TabContext } from '@material-ui/lab';
import {
  Breadcrumb,
  BackdropCircular
} from 'components';
import { getStoreEmailsConfigsDataApi } from 'api';
import StoreConfigurationsReceivingEmails from './StoreConfigurationsReceivingEmails';
import StoreConfigSendingEmail from './StoreConfigSendingEmail';
import { useStyles } from './styles';


const StoreConfigurationEmails = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const regexOneEmailAllowed = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;

  const {
    storeEmailsData,
    loadingStoreEmailsDataConfigs
  } = useSelector((state: IReduxState) => state.store_configs);

  const [tabIndex, setTabIndex] = useState('sendingEmails');
  const primaryEmail = storeEmailsData.find((item) => item.path == 'trans_email/ident_general/email')?.value;
  const [primaryEmailField, setPrimaryEmailField] = useState(primaryEmail);

  const handleTabChange = (e, value) => setTabIndex(value);

  useEffect(() => {
    if (storeEmailsData.length === 0) {
      getStoreEmailsConfigsDataApi({dispatch});
    }
  }, []);

  useEffect(() => {
    setPrimaryEmailField(primaryEmail);
  }, [primaryEmail]);

  return (
    <div className="scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Store Configurations', path: '/settings#store_configurations' },
            { name: 'Store Emails' }
          ]}
        />
      </div>
      <div className="m-10">
        <div className="mb-10 text-dark-gray">
          <h3>Store Emails</h3>
          <h5>Configure your Store&apos;s Sending and Receiving Emails</h5>
        </div>
        <Card>
          <TabContext value={tabIndex}>
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              textColor="primary"
              indicatorColor="primary"
              className={classes.tabsContainer}
            >
              <Tab className="capitalize font-medium font-bold" value="sendingEmails" label="Sending Email" />
              <Tab className="capitalize font-medium font-bold" value="receivingEmails" label="Receiving Emails" />
            </Tabs>
            <TabPanel value="sendingEmails">
              <StoreConfigSendingEmail
                regexOneEmailAllowed={regexOneEmailAllowed}
                primaryEmailField={primaryEmailField}
                setPrimaryEmailField={setPrimaryEmailField}
                storeEmailsData={storeEmailsData}
              />
            </TabPanel>
            <TabPanel value="receivingEmails">
              <StoreConfigurationsReceivingEmails />
            </TabPanel>
          </TabContext>
        </Card>
      </div>
      <BackdropCircular loading={loadingStoreEmailsDataConfigs} />
    </div>
  );
};


export default StoreConfigurationEmails;
